import { GlobalStatusEnum } from "@/model/data/status/GlobalStatusEnum";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { IFilterInstallations } from "../supportObjects/IFilterInstallations";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { FetchInstallationsContentResponse } from "./FetchInstallationsContentResponse";

const ENDPOINT = "/cash_flow/content";

export class FetchInstallationsContentCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: FetchInstallationsContentRequestData;

    constructor(payload: FetchInstallationsContentRequestData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<FetchInstallationsContentResponse> {
        let res = await this.executeCommand(this.payload);
        return new FetchInstallationsContentResponse(res);
    }
}

export class FetchInstallationsContentRequestData implements IFilterInstallations, IPaginationFilter {
    // FilterInstallations
    installationNames: string[] = null;
    folderIds: number[] = null;
    branchNames: string[] = [];

    // PaginationFilters
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    // Other filters
    globalStatusFilter: GlobalStatusEnum[] = [];
    installationLastMessageDateRange: string[] = [];
    agentLastMessageDateRange: string[] = [];
}
